import distance from '@turf/distance';
import { point, Units } from '@turf/helpers';
import { Point } from '../types';

export const isInBoundingBox = (bounds: number[][], coordinates: [number, number]): boolean => {
  const [minLng, minLat] = bounds[0];
  const [maxLng, maxLat] = bounds[1];
  const [lng, lat] = coordinates;
  return lng >= minLng && lng <= maxLng && lat >= minLat && lat <= maxLat;
};

export const computeDistance = (p1: Point, p2: Point, units: Units): number => {
  const from = point(p1.coordinates);
  const to = point(p2.coordinates);
  return distance(from, to, { units });
};
